var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function SmoothScroll(el) {
  $('a[href*="#"]:not([href="#"])').on('click', function(e) {
    e.preventDefault();
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      headerHeight = $('.header').innerHeight();
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - headerHeight - 30
        }, 1000);
        return false;
      }
    }
  })
}

module.exports = SmoothScroll;
